import React from 'react';
import PropTypes from 'prop-types';

import {
  IconButton,
  Tooltip,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import { fmtS3ConsoleLink } from '../../utils/formatters';

import { BucketIcon } from '.';

const useStyles = makeStyles((theme) => ({
  root: {
  },
}));

export default function BucketIconButton(props) {
  const { s3uri, tooltip } = props;
  const classes = useStyles();

  const handleGoToBucket = () => {
    window.open(fmtS3ConsoleLink(s3uri),"_blank");
  };

  if(s3uri) {
    return (
      <Tooltip title={tooltip}>
        <IconButton className={classes.root} onClick={handleGoToBucket} {...props}>
          <BucketIcon/>
        </IconButton>
      </Tooltip>
    );
  } else {
    return(null);
  }
}

BucketIconButton.propTypes = {
  s3uri: PropTypes.string,
  tooltip: PropTypes.string.isRequired,
};

BucketIconButton.defaultProps = {
  tooltip: "Go to bucket",
};
